var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA11YmenuStatdonut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.75 2.2912V4.98546C11.4038 5.29245 12.7076 6.59619 13.0147 8.25H15.7088C15.3629 5.12129 12.8787 2.63706 9.75 2.2912ZM15.7088 9.75H13.0147C12.6626 11.647 10.9991 13.0834 9.00008 13.0834C6.74492 13.0834 4.91675 11.2552 4.91675 9.00008C4.91675 7.00114 6.3531 5.33768 8.25 4.98549V2.2912C4.87504 2.66428 2.25 5.52558 2.25 9C2.25 12.7279 5.27208 15.75 9 15.75C12.4744 15.75 15.3357 13.125 15.7088 9.75ZM17.25 9C17.25 4.44365 13.5563 0.75 9 0.75C4.44365 0.75 0.75 4.44365 0.75 9C0.75 13.5563 4.44365 17.25 9 17.25C13.5563 17.25 17.25 13.5563 17.25 9ZM9.00008 6.41675C10.4235 6.41675 11.578 7.56798 11.5834 8.99015L11.5833 9L11.5834 9.00988C11.5781 10.4321 10.4235 11.5834 9.00008 11.5834C7.57335 11.5834 6.41675 10.4268 6.41675 9.00008C6.41675 7.57335 7.57335 6.41675 9.00008 6.41675Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgA11YmenuStatdonut);
export default __webpack_public_path__ + "static/media/a11ymenu_statdonut.69f8ca54628454bd589c948923846875.svg";
export { ForwardRef as ReactComponent };